import { useEffect } from 'react';

const BuyMeACoffee = () => {
  useEffect(() => {
    // Check if the script is already loaded
    if (document.querySelector('script[data-name="BMC-Widget"]')) {
      return;
    }

    const script = document.createElement('script');
    script.setAttribute('data-name', 'BMC-Widget');
    script.setAttribute('data-cfasync', 'false');
    script.src = 'https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js';
    script.setAttribute('data-id', 'sportsfuture');
    script.setAttribute('data-description', 'Support me on Buy me a coffee!');
    script.setAttribute('data-message', 'Thank you for sharing the passion to empower athletes around the world !');
    script.setAttribute('data-color', '#5F7FFF');
    script.setAttribute('data-position', 'Right');
    script.setAttribute('data-x_margin', '18');
    script.setAttribute('data-y_margin', '18');
    script.async = true;

    document.body.appendChild(script);

    return () => {
      // Cleanup on unmount
      const existingScript = document.querySelector('script[data-name="BMC-Widget"]');
      if (existingScript) {
        existingScript.remove();
      }
      // Also remove the widget container if present
      const widget = document.getElementById('bmc-wbtn');
      if (widget) {
        widget.remove();
      }
    };
  }, []);

  return null; // This component only loads the script, no visual rendering needed
};

export default BuyMeACoffee;
